module.exports = "https://hwyhw-static.smarket.net.cn/519/seminar/2202102963240899/minisite/da2c87b679b3d79fe465d972682f132c.png";